module.exports = __webpack_public_path__ + "static/media/button-picture.377c76d7.svg";